import React from 'react';
import styled from 'styled-components';
import { FaQuoteLeft } from 'react-icons/fa';

// CONTEÚDO PLACEHOLDER — substituir por depoimentos e números reais antes de portar para produção (web/).
// Ver specs/WEB-COPY-REDESIGN-AND-SEO.spec.md §4.2.
const testimonials = [
  {
    quote: 'Depois do SofChef, reduzi 30% do tempo que gastava fechando o caixa todo dia.',
    name: 'Marcos Ferreira',
    place: 'Botequim do Marcão',
  },
  {
    quote: 'O cardápio digital sozinho já se pagou no primeiro mês de uso.',
    name: 'Juliana Prado',
    place: 'Sabor & Cia',
  },
  {
    quote: 'Consegui controlar as 3 unidades pelo celular, sem precisar estar lá.',
    name: 'Renato Lima',
    place: 'Grupo Renatinho Lanches',
  },
];

const Section = styled.section`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 5rem 0;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 4rem 1.5rem;
  }
`;

const StatBanner = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.6rem;
  text-align: center;
  margin-bottom: 4rem;
`;

const StatNumber = styled.span`
  font-family: var(--font-display);
  font-size: clamp(1rem, 1vw, 1rem);
  font-weight: 700;
  color: var(--color-accent-hover);
`;

const StatLabel = styled.span`
  font-family: var(--font-body);
  font-size: 1.05rem;
  color: var(--color-ink-soft);
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 1.3rem;

  @media screen and (max-width: 768px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(2rem, 3.5vw, 4rem);
  font-weight: 700;
  color: var(--color-brand-deep);

  @media screen and (max-width: 768px){
    width: 100%;
    font-size: clamp(1.7rem, 2vw, 2rem);
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  position: relative;
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 2rem;

  &:nth-child(2) {
    border-color: var(--color-accent);
    box-shadow: var(--shadow-soft);
  }
`;

const QuoteIcon = styled(FaQuoteLeft)`
  color: var(--color-accent);
  opacity: 0.35;
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const Quote = styled.p`
  font-family: var(--font-body);
  font-size: 1.05rem;
  color: var(--color-ink);
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const AuthorRow = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorName = styled.span`
  font-family: var(--font-body);
  font-weight: 700;
  color: var(--color-ink);
`;

const AuthorPlace = styled.span`
  font-family: var(--font-body);
  font-size: 0.9rem;
  color: var(--color-ink-soft);
`;

const Testimonials = () => {
  return (
    <Section id="testimonials">
      <Header>
        <Title>Quem usa, <span style={{color: '#005586'}}>recomenda</span>!</Title>
      </Header>

      <StatBanner>
        <StatNumber>+250</StatNumber>
        <StatLabel>restaurantes e bares usam o SofChef todos os dias</StatLabel>
      </StatBanner>

      <Grid>
        {testimonials.map((testimonial) => (
          <Card key={testimonial.name}>
            <QuoteIcon aria-hidden="true" />
            <Quote>{testimonial.quote}</Quote>
            <AuthorRow>
              <AuthorName>{testimonial.name}</AuthorName>
              <AuthorPlace>{testimonial.place}</AuthorPlace>
            </AuthorRow>
          </Card>
        ))}
      </Grid>
    </Section>
  );
};

export default Testimonials;
